/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PostureRegionModel {
    getFixupPrototypeFunction() { return PostureRegionModel.fixupPrototype; }

    static newInstance(model: Partial<PostureRegionModel>): PostureRegionModel {
        let obj = Object.assign(new PostureRegionModel(), model);
        PostureRegionModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PostureRegionModel>): PostureRegionModel {
        if (!model) return null;
        return PostureRegionModel.newInstance(<PostureRegionModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PostureRegionModel) {
        if (!obj) return;

        models.PostureRegionModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PostureRegionModel): boolean {
        Object.setPrototypeOf(obj, PostureRegionModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count === undefined) {
            this.count = 0;
        }
        if (this.billable === undefined) {
            this.billable = 0;
        }
        if (this.non_billable === undefined) {
            this.non_billable = 0;
        }
    }

    /**
     * region name
     */
    region: string;

    /**
     * total count details
     */
    count: number;

    /**
     * billable count details
     */
    billable: number;

    /**
     * non_billable count details
     */
    non_billable: number;

}
